/******/ (() => { // webpackBootstrap
/******/ 	"use strict";

;// ./src/js/AnnoucementBar.js
class AnnoucementBar {
  constructor() {
    this.announcementBarSelector = ".announcement-bar";
    this.headerSelector = ".header-section";
  }

  init = () => {
    const announcementBar = document.querySelector(this.announcementBarSelector);
    const header = document.querySelector(this.headerSelector);
    if (!announcementBar || !header) {
      return;
    }

    header.style.top = `${announcementBar.offsetHeight}px`;
  };
}

;// ./src/js/PaginationCollection.js
class PaginationCollection {
  constructor() {
    this.totalPages = window.collectionTotalPages;
    this.currentPage = 1;
    this.paginationButtonSelector = ".pagination";
  }

  init = () => {
    const paginationButton = document.querySelector(this.paginationButtonSelector);
    if (!paginationButton) {
      return;
    }

    document.addEventListener("pagination:page-changed", e => {
      this.currentPage = Number(e.detail.url.split("?page=")[1]);
      if (this.currentPage >= this.totalPages) {
        paginationButton.style.display = "none";
      }
    });
  };
}

;// ./src/js/Product.js
class Product {
  constructor() {
    this.productSelector = ".template-product";
    this.eanSelector = ".product-title__ean";
    this.eanValueSelector = ".product-title__ean-value";
  }

  init = () => {
    const product = document.querySelector(this.productSelector);

    if (!product) {
      return;
    }

    const ean = product.querySelector(this.eanSelector);
    if (!ean) {
      return;
    }

    const eanValue = ean.querySelector(this.eanValueSelector);
    if (!eanValue) {
      return;
    }

    document.addEventListener("product:variant-change", e => {
      eanValue.innerText = e.detail.variant.barcode;
      if (!e.detail.variant.barcode) {
        ean.style.opacity = 0;
      } else {
        ean.style.opacity = 1;
      }
    });
  };
}

;// ./src/main.js




// JS goes here

window.addEventListener("load", () => {
  const classes = [new AnnoucementBar(), new Product(), new PaginationCollection()];
  classes.forEach(classe => classe.init());
});

/******/ })()
;